import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-597e6dac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "is-relative layout"
}
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-6" }
const _hoisted_4 = { class: "is-flex is-align-items-center gap-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title is-6 mb-0" }, " Input CSVs ", -1))
const _hoisted_6 = { class: "column is-1" }
const _hoisted_7 = { class: "has-text-centered" }
const _hoisted_8 = { class: "column is-5" }
const _hoisted_9 = { class: "is-flex is-align-items-center gap-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title is-6 mb-0" }, " Output tables ", -1))
const _hoisted_11 = {
  key: 0,
  class: "sources"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "arrows" }
const _hoisted_15 = ["data-arrow-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_csv_source_mapping = _resolveComponent("csv-source-mapping")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_loading_block = _resolveComponent("loading-block")!

  return (_ctx.mapping && _ctx.sourcesCollection && _ctx.tableCollection)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_hydra_operation_button, {
                operation: _ctx.sourcesCollection.actions.create,
                to: { name: 'CSVUpload' },
                "data-testid": "upload-source"
              }, null, 8, ["operation"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createVNode(_component_o_icon, {
                icon: "arrow-right",
                size: "small"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_hydra_operation_button, {
                operation: _ctx.tableCollection.actions.create,
                to: { name: 'TableCreate' },
                disabled: _ctx.sources.length === 0,
                "data-testid": "create-table"
              }, null, 8, ["operation", "disabled"])
            ])
          ])
        ]),
        (_ctx.sources.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source, index) => {
                return (_openBlock(), _createBlock(_component_csv_source_mapping, {
                  key: source.id.value,
                  source: source,
                  "is-first-source": index === 0,
                  "table-collection": _ctx.tableCollection,
                  tables: _ctx.tables,
                  onHighlightArrows: _ctx.highlightArrows,
                  onUnhighlightArrows: _ctx.unhighlightArrows
                }, null, 8, ["source", "is-first-source", "table-collection", "tables", "onHighlightArrows", "onUnhighlightArrows"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_12, [
              _createTextVNode(" You haven't uploaded any CSV file yet. "),
              (_ctx.sourcesCollection.actions.create)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    _createTextVNode(" Do you want to "),
                    _createVNode(_component_router_link, { to: { name: 'CSVUpload' } }, {
                      default: _withCtx(() => [
                        _createTextVNode(" upload one ")
                      ]),
                      _: 1
                    }),
                    _createTextVNode("? ")
                  ]))
                : _createCommentVNode("", true)
            ])),
        (_openBlock(), _createElementBlock("svg", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnMappings, (columnMapping) => {
            return (_openBlock(), _createElementBlock("path", {
              key: columnMapping.id.value,
              "data-arrow-id": columnMapping.id.value,
              class: _normalizeClass(["arrow", { active: _ctx.activeArrows.includes(columnMapping.id.value) }])
            }, null, 10, _hoisted_15))
          }), 128))
        ])),
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createBlock(_component_loading_block, { key: 1 }))
}